import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotAuthGuardService } from '../auth/not-auth-guard.service';
import { CertificatesComponent } from './certificates/certificates.component';
import { AuthGuardService } from '../auth/auth-guard.service';
import { EventsComponent } from './events/events.component';
import { FactoryProfileComponent } from './factory-profile/factory-profile.component';
import { ProductsComponent } from './products/products.component';
import { SponsoringComponent } from './sponsoring/sponsoring.component';
import { UsersComponent } from './users/users.component';
import { ManufacturerGuardService } from './manufacturer-guard.service';
import { BillingComponent } from './sponsoring/billing/billing.component';
import { DashboardComponent } from '../dashboard/dashboard/dashboard.component';
import { DistributorManufacturerGuardService } from '../shared/distributor-manufacturer-guard.service';
import { PlansAndPricingComponent } from './plans-and-pricing/plans-and-pricing.component';
import { PlansBillingComponent } from './plans-billing/plans-billing.component';
import { DistributorGuardService } from '../distributor/distributor-guard.service';
import { ChildDistributorGuardService } from '../distributor/child-distributor-guard.service';
import { ManufacturerChildGuardService } from './manufacturer-child-guard.service';
import { StatisticsComponent } from '../statistics/statistics/statistics.component';
import {CardBillingComponent} from "./sponsoring/billing/card-billing/card-billing.component";

const manufacturerRoutes: Routes = [
  { path: '', children: [
    { path: '', component: DashboardComponent, canActivate: [AuthGuardService] },
    { path: 'certificates', component: CertificatesComponent, canActivate: [AuthGuardService, DistributorManufacturerGuardService]},
    { path: 'events', component: EventsComponent, canActivate: [AuthGuardService, DistributorManufacturerGuardService]},
    { path: 'factory-profile', component: FactoryProfileComponent, canActivate: [AuthGuardService, ManufacturerGuardService]},
    { path: 'products', component: ProductsComponent, canActivate: [AuthGuardService, DistributorManufacturerGuardService]},
    { path: 'sponsoring', component: SponsoringComponent, canActivate: [AuthGuardService, DistributorManufacturerGuardService]},
    { path: 'billing/:count', component: BillingComponent, canActivate: [AuthGuardService, DistributorManufacturerGuardService]},
    { path: 'statistics', component: StatisticsComponent, canActivate: [AuthGuardService, DistributorManufacturerGuardService]},
    { path: 'pricing-and-plans', component: PlansAndPricingComponent, canActivate: [AuthGuardService, DistributorManufacturerGuardService]},
    { path: 'manufacturer-users', component: UsersComponent, canActivate: [AuthGuardService, ManufacturerGuardService]},
    { path: 'plan-billing/:count', component: PlansBillingComponent, canActivate: [AuthGuardService, DistributorManufacturerGuardService]},
    { path: 'billing', component: BillingComponent, canActivate: [AuthGuardService, ManufacturerGuardService]},
    { path: 'card-billing/:count', component: CardBillingComponent, canActivate: [AuthGuardService, ManufacturerGuardService]},
    { path: 'pricing-and-plans', component: PlansAndPricingComponent, canActivate: [AuthGuardService, DistributorManufacturerGuardService]},
    { path: 'manufacturer-users', component: UsersComponent, canActivate: [AuthGuardService, ManufacturerChildGuardService]},
    { path: 'distributor-users', component: UsersComponent, canActivate: [AuthGuardService, ChildDistributorGuardService]},
    ] }
];

@NgModule({
  imports: [RouterModule.forChild(manufacturerRoutes)],
  exports: [RouterModule]
})
export class ManufacturerRoutingModule { }
